function isRecord(value) {
  return typeof value == "object" && value !== null && !Array.isArray(value);
}
export {
  isRecord
};
//# sourceMappingURL=isRecord.js.map
